import { render, staticRenderFns } from "./tabs-body.vue?vue&type=template&id=edfc84f6&scoped=true&"
import script from "./tabs-body.vue?vue&type=script&lang=js&"
export * from "./tabs-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfc84f6",
  null
  
)

export default component.exports